import { deepMerge } from 'js/utils/Utils'
import { gsap } from 'gsap'

import Common from 'js/_core/Common'
import { getTargetOffsetTop } from 'js/utils/Utils'

const defaults = {
  instanceName: 'headerColor',
  $names: {
    header: '[data-header]',
    bgSection: '[data-bg-section]',
  },
  className: {
    bgWhite: 'is-bg_white',
  },
  dataNames: {
    bgSection: 'bgSection',
  },
}

export default class HeaderColor {
  $root = document
  $header = null

  $content = null

  $bgSections = []
  bgSectionInfo = []

  currentScroll = 0
  prevScroll = 0
  cssVars = {
    white: {
      '--cl-header-text': '#0d0d0d',
      '--cl-header-icon': '#f1f1f1',
    },
    black: {
      '--cl-header-text': '#f1f1f1',
      '--cl-header-icon': '#0d0d0d',
    },
  }

  currentTheme = 'unknown' // ← 現在の状態を記録する

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._setInit$()
    this._addHandlers()
  }

  destroy() {
    this._removeHandlers()
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => {
        this.onRaf()
      }, this.instanceName)
    }

    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, this.instanceName)
    }
  }

  _removeHandlers() {
    if (Common.raf) {
      Common.raf.removeHandler(this.instanceName)
    }

    if (Common.resize) {
      Common.resize.removeHandler(this.instanceName)
    }
  }

  pageEnter($content) {
    if ($content) {
      this.$content = $content
      this.currentTheme = ''
      this._set$()
      this._setInfo()
      this._setPos()
      this.checkBgSection()
    }
  }

  pageLeave() {
    this.bgSectionInfo = []
    this.$header.classList.remove(this.className.bgBlack)
  }

  _setInit$() {
    this.$header = this.$root.querySelector(this.$names.header)
  }

  _set$() {
    this.$bgSections = this.$content.querySelectorAll(this.$names.bgSection)
  }

  _setInfo() {
    this.$bgSections.forEach(($bgSection, i) => {
      this.bgSectionInfo[i] = {
        $bgSection: $bgSection,
        bgSectionType: $bgSection.dataset[this.dataNames.bgSection] || '',
        top: 0,
        bottom: 0,
      }
    })
  }

  _setPos() {
    this.bgSectionInfo.forEach((info) => {
      info.top = getTargetOffsetTop(info.$bgSection) - this.$header.clientHeight * 0.5
      info.bottom = info.top + info.$bgSection.clientHeight
    })
  }

  checkBgSection() {
    this.currentScroll = document.documentElement.scrollTop || document.body.scrollTop

    let nextTheme = 'black'

    if (Common.headerManager.isMenuOpened || (Common.spMenu && Common.spMenu.isMenuOpened)) {
      nextTheme = 'white'
    } else {
      this.bgSectionInfo.forEach((info) => {
        if (this.currentScroll >= info.top && this.currentScroll <= info.bottom && info.bgSectionType === 'white') {
          nextTheme = 'white'
        }
      })
    }

    if (nextTheme === this.currentTheme) return // 状態が変わらなければ何もしない

    this.currentTheme = nextTheme

    gsap.killTweensOf(document.documentElement, [this.cssVars.white, this.cssVars.black])

    gsap.to(document.documentElement, {
      // duration: 0.2,
      ...this.cssVars[nextTheme],
      // ease: 'quad.out',
      duration: 0.3,
      ease: 'none',
    })
  }

  onRaf() {
    this.checkBgSection()
  }

  onResize() {
    this._setPos()
  }
}